export default "__VITE_ASSET__DVfWfNBK__"